const locationAndClasstype = {
    state: {
        addLocationAndClasstypeDialog: {
            title: '新增地点和班级类型信息',
            type: 'add'
        }
    },
    getters: {
        addLocationAndClasstypeDialog: state => state.addLocationAndClasstypeDialog,
    },
    mutations: {
        SET_LOCATION_CLASSTYPE_DIALOG_TITLE: (state, type) => {
            if (type === 'add') {
                state.addLocationAndClasstypeDialog.title = '新增地点和班级类型信息'
                state.addLocationAndClasstypeDialog.type = 'add'
            } else {
                state.addLocationAndClasstypeDialog.title = '编辑地点和班级类型信息'
                state.addLocationAndClasstypeDialog.type = 'edit'
            }
        }
    },
    actions: {

    }
}

export default locationAndClasstype